import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { headers, baseUrl } from "../../api/utils";

export const getCurrentPlanRedux = createAsyncThunk(
    'currentPlan/fetch',
    async () => {
        const response = await axios.get(`${baseUrl}/vendor/getcurrentplan`, {
            headers: headers
        });
        return response.data;
    }
);

const currentPlanSlice = createSlice({
    name: 'currentPlan',
    initialState: {
        planData: null,
        planStatus: 'idle',
        planError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCurrentPlanRedux.pending, (state) => {
                state.planStatus = 'loading';
            })
            .addCase(getCurrentPlanRedux.fulfilled, (state, action) => {
                state.planStatus = 'succeeded';
                console.log(action.payload,"action");
                
                state.planData = action.payload;
            })
            .addCase(getCurrentPlanRedux.rejected, (state, action) => {
                state.planStatus = 'failed';
                state.planError = action.error.message;
            });
    },
});

export default currentPlanSlice.reducer;
export { getCurrentPlanRedux as fetchCurrentPlan };